import Icon from '../components/Icon.vue'

Icon.register({
  ghost: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M186.1 0.1c108.7-3.3 197.9 83.9 197.9 191.9v272c0 14.3-17.2 21.4-27.3 11.3l-24.9-18.5c-6.7-5-16-4-21.5 2.2l-43 48.3c-6.3 6.3-16.4 6.3-22.6 0l-40.7-45.8c-6.4-7.2-17.5-7.2-23.9 0l-40.7 45.8c-6.3 6.3-16.4 6.3-22.6 0l-43-48.3c-5.5-6.2-14.9-7.2-21.5-2.2l-24.9 18.5c-10.1 10.1-27.3 3-27.3-11.3v-263.9c0-105.1 81-196.8 186.1-200zM128 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM256 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ghost.js
// module id = 1383
// module chunks = 0